const endpointsAuth = {
  LOGIN: '/v1/login',
  LOGOUT: '/v1/logout',
  REFRESH_TOKEN: '/v1/refreshToken',
  RECOVERPASSWORD: '/v1/recoverPassword',
  NEWPASSWORD: '/v1/newPassword',
}

export { endpointsAuth }
